const resultFunction = (form) => form.prefillOptionId;
const prefillOptionIdSelectorDefinition = {
    id: 'prefillOptionId',
    resultFunction,
    dependencies: [{ selector: 'form' }],
};
export default prefillOptionIdSelectorDefinition;
